import axios from "~src/utils/axios";
import type { IItemString } from "~src/interfaces/commom";
import {
  API_BADMINTON_URL,
  API_BASEBALL_URL,
  API_BASKETBALL_URL,
  API_ESPORTS_URL,
  API_FOOTBALL_URL,
  API_LIVE_URL,
  API_TENNIS_URL,
  API_VOLLEYBALL_URL,
  API_XL_SCORE_URL,
  API_OPT_SEARCH_SCORE_URL
} from "~src/utils/constant";

const BASE_URL: IItemString = {
  football: API_FOOTBALL_URL,
  basketball: API_BASKETBALL_URL,
  tennis: API_TENNIS_URL,
  badminton: API_BADMINTON_URL,
  volleyball: API_VOLLEYBALL_URL,
  baseball: API_BASEBALL_URL,
  // esports
  csgo: API_ESPORTS_URL,
  lol: API_ESPORTS_URL,
  dota2: API_ESPORTS_URL,
};

const getApiUrl = (sportType: string, path: string) => {
  return `${BASE_URL[sportType]}/${path}`;
};

const getApiUrlFootballBySiteName = (siteName: string, path: string) => {
  return `${API_LIVE_URL}/v1/${siteName}${path}`;
};

const getApiUrlFootballBySiteNameNew = (siteName: string, path: string) => {
  return `${API_XL_SCORE_URL}/${siteName}${path}`;
};

const getApiUrlSearchBySport = (query: string, sport: string = 'football', index: string = '') => {
  return `${API_OPT_SEARCH_SCORE_URL}/api/v2/search/all/?sport=${sport}&page=1&q=${query}${index ? `&index=${index}` : ''}`;
};

export const countryAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/country/all`);
  return await axios.get(url);
};

export const categoryAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/category/all`);
  return await axios.get(url);
};

export const competitionAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/competition/all`);
  return await axios.get(url);
};

export const competitionFeatured = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/competition/featured`);
  return await axios.get(url);
};

export const matchSchedule = async (
  filterDate: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/schedule/${filterDate}`);
  return await axios.get(url);
};

export const scheduleBySeasonId = async (
  seasonId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/schedule/${seasonId}/season`);
  return await axios.get(url);
};

export const competitionDetail = async (
  competitionId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/competition/${competitionId}`);
  return await axios.get(url);
};

export const matchRecent = async (ymd: string, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/recent/${ymd}`);
  return await axios.get(url);
};

export const matchHighlights = async (ymd: string, siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteName(siteName, `/highlight/date/${ymd}`);
  return await axios.get(url);
};

export const matchHighlightsByCompetitionId = async (competitionId: string, siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteName(siteName, `/highlight/competition/${competitionId}`);
  return await axios.get(url);
};

export const matchRecentInverse = async (
  ymd: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/recent/${ymd}/inverse`);
  return await axios.get(url);
};

export const matchDetailLive = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/detail_live`);
  return await axios.get(url);
};

export const matchDetailLiveEsport = async (sportType = "lol") => {
  const url = getApiUrl(sportType, "esports/match/detail_live");
  return await axios.get(url);
};

export const matchDetail = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}`);
  return await axios.get(url);
};

export const matchIncidents = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/incidents`);
  return await axios.get(url);
};

export const matchStatistics = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/statistics`);
  return await axios.get(url);
};

export const matchSquads = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/squads`);
  return await axios.get(url);
};

export const matchIncidentsHome = async (
  sportType: string,
  matchId: string
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/incidents`);
  return await axios.get(url);
};

export const matchStatisticsHome = async (
  sportType: string,
  matchId: string
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/statistics`);
  return await axios.get(url);
};

export const matchLineups = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/lineups`);
  return await axios.get(url);
};

export const seasonMatches = async (
  seasonId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/season/${seasonId}/matches`);
  return await axios.get(url);
};

export const matchH2h = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/h2h`);
  return await axios.get(url);
};

export const matchStanding = async (seasonId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/standing/${seasonId}`);
  return await axios.get(url);
};

export const mappingThesport = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/mapping/${matchId}/thesport`);
  return await axios.get(url);
};

export const shootingPointsMatch = async (
  matchId: any,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/shooting`);
  return await axios.get(url);
};

export const seasonBracketMatch = async (
  matchId: any,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/season/${matchId}/bracket`);
  return await axios.get(url);
};

export const getOddsMatch = async (sportType: any, matchId: any) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/odd`);
  return await axios.get(url);
};

export const getRealtimeDetail = async (matchId: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/match/${matchId}/realtime-detail`
  );
  return await axios.get(url);
};

export const getTeamOverview = async (teamID: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/team/${teamID}/overview`
  );
  return await axios.get(url);
};

export const getTeamSalary = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/salary`);
  return await axios.get(url);
};

export const getTeamSchedule = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/schedule`);
  return await axios.get(url);
};
export const getTeamLineup = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/lineup`);
  return await axios.get(url);
};
export const getTeamPlayerTransfer = async (teamID: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/team/${teamID}/player-transfer`
  );
  return await axios.get(url);
};
export const getTeamHonor = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/honor`);
  return await axios.get(url);
};

export const getTeamPlayerStats = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/player-stats`);
  return await axios.get(url);
};

export const getPlayerStatistics = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/statistics`
  );
  return await axios.get(url);
};

export const getPlayerHistoryMatches = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/history-matches`
  );
  return await axios.get(url);
};

export const getPlayerHistorySeasons = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/history-seasons`
  );
  return await axios.get(url);
};

export const getPlayerCareer = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/career`
  );
  return await axios.get(url);
};

export const getPostList = async (siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteNameNew(siteName, `/v1/category/list`);
  return await axios.get(url);
};

export const getSearchResults = async (
  query: string,
  sportType = "football",
  index: string = ""
) => {
  const url = getApiUrlSearchBySport(query, sportType, index);
  return await axios.get(url);
};

export const getTopPlayers = async () => {
  return await axios.get(`${API_FOOTBALL_URL}/football/top-players`);
};

export const getTopScorePlayersBySeasonId = async (seasonId: string) => {
  return await axios.get(`${API_FOOTBALL_URL}/football/player/${seasonId}/top-scorer`);
};

export const getSuggestCompetitions = async () => {
  return await axios.get(`${API_OPT_SEARCH_SCORE_URL}/api/v2/search/suggest/competitions?lang=VI&sport=football`);
};
